import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinnerThird } from '@fortawesome/pro-solid-svg-icons/faSpinnerThird';
import styles from './Spinner.module.scss';

export default function Spinner({ loading }) {
  if (loading) {
    return (
      <div className={styles.spinner}>
        <FontAwesomeIcon icon={faSpinnerThird} className={styles.spinner__icon} />
      </div>
    );
  }
}
